import { render, staticRenderFns } from "./JSelectRole.vue?vue&type=template&id=f0dcba9e&scoped=true&"
import script from "./JSelectRole.vue?vue&type=script&lang=js&"
export * from "./JSelectRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dcba9e",
  null
  
)

export default component.exports